import { Badge } from "src/components/Badge/Badge";
import { PostWithUser } from "../../types/index.type";
import { getUserRoleBadgeClasses } from "../../utils/posts-style";
import { TAALY } from "src/utils/constants.util";

// User Info Component
type UserInfoProps = {
  user: PostWithUser["user"];
  post: PostWithUser["post"];
};
export const UserInfo = ({ user, post }: UserInfoProps) => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2">
        {user ? (
          <>
            <img
              src={user.pictureURL || "https://via.placeholder.com/32x32?text=U"}
              alt={user.name}
              className="w-8 h-8 rounded-full object-cover border-2 transition-colors duration-300
              border-gray-200"
            />
            <h3 className="text-lg font-semibold text-gray-900">{user.name}</h3>
          </>
        ) : post.userId === TAALY ? (
          <>
            <img
              src="/taaly-logo.png"
              alt={TAALY}
              className="w-8 h-8 rounded-full object-cover border-2 transition-colors duration-300
              border-gray-200"
            />
            <h3 className="text-lg font-semibold text-gray-900">{TAALY}</h3>
          </>
        ) : (
          <>
            <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-sm font-semibold">
              {post.userId.charAt(0).toUpperCase()}
            </div>
            <h3 className="text-lg font-semibold text-gray-900">{post.userId}</h3>
          </>
        )}
      </div>
      {post.userId !== TAALY ? (
        <Badge
          classes={`${getUserRoleBadgeClasses(post.role)} font-medium px-2.5 py-1 rounded-full text-xs`}
          label={post.role}
        />
      ) : null}
    </div>
  );
};
